import {Badge} from '@material-ui/core';
import React from 'react';
import {Theme, withStyles, createStyles} from '@material-ui/core/styles';
interface CustomBadgeComponentProps {
  count: number;
}
const StyledBadge = withStyles((theme: Theme) =>
  createStyles({
    badge: {
      position: 'absolute',
      lineHeight: 0
    }
  })
)(Badge);

const CustomBadge: React.FC<CustomBadgeComponentProps> = props => {
  const {count} = props;
  return <StyledBadge badgeContent={count} color="error" />;
};

export default CustomBadge;
